import { PageHeaderWrapper, Text, Title } from "@clipboard-health/ui-components";
import { Box, DialogContent, Stack } from "@mui/material";
import { environmentConfig } from "@src/appV2/environment";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { TextButton } from "@src/appV2/redesign/components/TextButton";

const BADGE_IMAGE_URL = `${environmentConfig.REACT_APP_PUBLIC_ASSETS_BASE_URL}/images/badge-policy/badgeImage.png`;

export interface BadgeVerificationIntroContentRedesignProps {
  onBack: () => void;
  onTakePhoto: () => void;
  onNoBadge: () => void;
  onWhyBadgeRequired?: () => void;
}

export function BadgeVerificationIntroContentRedesign(
  props: BadgeVerificationIntroContentRedesignProps
) {
  const { onBack, onTakePhoto, onNoBadge, onWhyBadgeRequired } = props;

  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow onClickBack={onBack} />
      </PageHeaderWrapper>

      <DialogContent
        sx={{
          paddingTop: 5,
        }}
      >
        <Stack alignItems="center" textAlign="center" spacing={10}>
          <Box
            component="img"
            src={BADGE_IMAGE_URL}
            alt="Badge illustration"
            sx={{ width: 200, height: 200, objectFit: "cover" }}
          />

          <Stack spacing={4} alignItems="center">
            <Title component="h1" variant="h3">
              Got your badge on?
            </Title>
            <Text
              variant="body1"
              color={(theme) => theme.palette.text.primary}
              sx={{ textAlign: "center" }}
            >
              Your badge tells staff and residents who you are and that you're working.
            </Text>
          </Stack>

          {onWhyBadgeRequired && (
            <TextButton size="large" onClick={onWhyBadgeRequired}>
              View badge policy
            </TextButton>
          )}
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onTakePhoto}>
          Yes, I'm wearing it
        </Button>
        <Button fullWidth variant="outlined" size="large" onClick={onNoBadge}>
          No, I don't have a badge
        </Button>
      </DialogFooter>
    </>
  );
}
